var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuthenticated)?_c('v-app',[_c('app-sidebar'),_vm._v(" "),_c('app-toolbar'),_vm._v(" "),_c('app-content'),_vm._v(" "),_c('connection-checker'),_vm._v(" "),_c('service-worker')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7103f873","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/DefaultLayout.vue
// module id = null
// module chunks = 